export interface ICauHinhSMSQuyTrinh {
    Id: number,
    IdQuyTrinh: number,
    ThoiGian: number,
    IdMucDo: number,
    IdBuoc: number,
    TenMucDo: string,
    ThuTuNhanSMS: number,
    Count_NhanVien:number,
    EditAble: boolean,
    Saving: boolean,
}
export class CauHinhSMSQuyTrinh implements ICauHinhSMSQuyTrinh {
    Id: number = 0;
    IdQuyTrinh: number = 0;
    ThoiGian: number = 0;
    IdMucDo: number = 0;
    IdBuoc: number = 0;
    TenMucDo: string = '';
    ThuTuNhanSMS: number = 0;
    Count_NhanVien:number=0;
    EditAble: boolean = false;
    Saving: boolean = false;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/cau-hinh-sms-quy-trinh.ts